import * as CampaignAPI from "../api/campaign";
import {
  type CampaignResponse,
  type CampaignUserResponse,
  type StartEmailVerificationResponse,
  type WorkflowProcessResponse,
  type GiftPreviewResponse
} from "../api/campaign";
import * as DummyCampaignAPI from "../dummyApi/campaign";
import { isDemoMode } from "../stores/mode";
import type { ApiResponse } from "../../types/api";

interface CampaignAPI {
  getCampaign: (campaignKey: string, timestamp: number) => Promise<CampaignResponse>;
  checkCampaignValidity: (campaignKey: string, timestamp: number) => Promise<ApiResponse>;
  getCampaignUser: () => Promise<CampaignUserResponse>;
  activateWorkflow: (selectedAddressId: number) => Promise<ApiResponse>;
  continueWorkflow: (processKey: string) => Promise<ApiResponse>;
  startEmailVerification: (campaignKey: string) => Promise<StartEmailVerificationResponse>;
  getWorkflowInfo: (workflowProcessKey: string) => Promise<WorkflowProcessResponse>;
  resetCampaignUserPhase: () => Promise<ApiResponse>;
  getGiftPreview: ({ itemKey, variation }: { itemKey: string; variation: string }) => Promise<GiftPreviewResponse>;
}

const getAPI = (): CampaignAPI => {
  return isDemoMode() ? DummyCampaignAPI : CampaignAPI;
};

export const getCampaign = async (campaignKey: string, timestamp: number): Promise<CampaignResponse> => {
  return getAPI().getCampaign(campaignKey, timestamp);
};

export const checkCampaignValidity = async (campaignKey: string, timestamp: number): Promise<ApiResponse> => {
  return getAPI().checkCampaignValidity(campaignKey, timestamp);
};

export const getCampaignUser = async (): Promise<CampaignUserResponse> => {
  return getAPI().getCampaignUser();
};

export const activateWorkflow = async (selectedAddressId: number): Promise<ApiResponse> => {
  return getAPI().activateWorkflow(selectedAddressId);
};

export const continueWorkflow = async (processKey: string): Promise<ApiResponse> => {
  return getAPI().continueWorkflow(processKey);
};

export const startEmailVerification = async (campaignKey: string): Promise<StartEmailVerificationResponse> => {
  return getAPI().startEmailVerification(campaignKey);
};

export const getWorkflowInfo = async (workflowProcessKey: string): Promise<WorkflowProcessResponse> => {
  return getAPI().getWorkflowInfo(workflowProcessKey);
};

export const resetCampaignUserPhase = (): Promise<ApiResponse> => {
  return getAPI().resetCampaignUserPhase();
};

export const getGiftPreview = async ({
  itemKey,
  variation
}: {
  itemKey: string;
  variation: string;
}): Promise<GiftPreviewResponse> => {
  return getAPI().getGiftPreview({ itemKey, variation });
};
